module.exports = __webpack_public_path__ + "static/img/1x2_popup_divergence_pc.18f7693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/1x2_popup_divergence_pc.png
// module id = OHxQ
// module chunks = 1